import OrderHistoryPage from './OrderHistoryPage';
import historyPageReducer from './reducer';

export { historyPageReducer };
export default OrderHistoryPage;
